<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'漏洞扫描'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">漏洞扫描</p>
			<p class="t-align-center serviceT mt-10 mb-20">Vulnerability scanning</p>
			<div class="m-0auto maxw-1400 pb-50">
				<p class="fz-24 f-blue line-50 f-bold">漏洞扫描意义</p>
				<p class="fz-24 line-26 mb-20 t-indent2 pb-20">使用基于网络的安全弱点扫描工具，根据其内置的漏洞测试方法、扫描策略，从网络中对扫描对象进行一系列的安全检查，从而发现可能存在的安全漏洞、安全隐患。</p>
				<div class="t-align-center pb-30">
					<img src="../../assets/img/service/u16.png" alt="">
				</div>
				<p class="fz-24 line-26 mb-20 t-indent2 pb-20">使用漏洞扫描工具可以实现远程自动化扫描，降低安全评估的工作量，并能根据需求输出评估结果或者报表，能够有效评估网络的安全状况。</p>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
</style>